export function countChanges(dataA, dataB) {
    var count = 0;
    for (var i = 0; i < dataA.length; i++) {
        if (dataA[i].value !== dataB[i].value) {
            count++;
        }
    }
    return count;
}
export function findChanges(dataA, dataB) {
    var changes = [];
    for (var i = 0; i < dataA.length; i++) {
        if (dataA[i].value !== dataB[i].value) {
            changes.push(i);
        }
    }
    return changes;
}
